import { getAltoErrorString, ErrorStringOptions } from './error';

export type AltoConsoleType = 'warn' | 'error';

/**
 * Function to display a warning in the console with an alto prefix and scope
 *
 * 'warn' should be used for:
 * - Accessibility warnings
 * - Deprecation warnings
 * - General prop warnings
 *
 * 'error' should be used when:
 * - Functionality will not work (but app won't crash)
 */
const altoConsoleBase = (
  type: AltoConsoleType,
  message: string,
  options?: ErrorStringOptions,
) => {
  if (process.env.NODE_ENV === 'production') return;
  console[type](getAltoErrorString(message, options || {}));
};

export const altoConsole = {
  warn: (message: string, options?: ErrorStringOptions) =>
    altoConsoleBase('warn', message, options),
  error: (message: string, options?: ErrorStringOptions) =>
    altoConsoleBase('error', message, options),
};
